import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { catchError, map, Observable, of, switchMap, timer } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class HealthcheckService {
  private readonly HEALTHCHECK_URL = `${environment.CRG_DIGITALIZATION_SERVICE_URL}/crg-sponsor-portal-service/api/v1/healthcheck/`;
  private readonly DELAY_MS = 1000;
  private http: HttpClient = inject(HttpClient);

  checkSession(): Observable<boolean> {
    return timer(this.DELAY_MS).pipe(
      switchMap(() =>
        this.http
          .get<{ message: string }>(this.HEALTHCHECK_URL, {
            withCredentials: true
          })
          .pipe(
            map((response) => response.message === 'OK'),
            catchError(() => of(false))
          )
      )
    );
  }
}
